import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

import '../css/CollabProcessSection.css';

class CollabProcessSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      activeTab: "standard",
      sectionTitle: {
        "zh": "合作流程",
        "en": "How to Collaborate?",
        "ja": "協業プロセス"
      },
      tabs: {
        standard: { "zh": "標準合作", "en": "Standard Collaboration", "ja": "標準コラボレーション" },
        launch: { "zh": "首發客戶", "en": "Launch Customer", "ja": "ローンチカスタマー" }
      },
      standardSteps: [
        {
          num: "01",
          title: { "zh": "選擇產品", "en": "Select", "ja": "製品選定" },
          desc: { "zh": "從 Nexuni 產品型錄中挑選適合的解決方案", "en": "Pick products from Nexuni's catalog", "ja": "Nexuniのカタログから製品を選択" }
        },
        {
          num: "02",
          title: { "zh": "諮詢討論", "en": "Consult", "ja": "コンサルティング" },
          desc: { "zh": "與我們的團隊安排會議討論需求", "en": "Schedule a meeting with our team", "ja": "チームとのミーティングを予約" }
        },
        {
          num: "03",
          title: { "zh": "取得報價", "en": "Quote", "ja": "見積もり" },
          desc: { "zh": "獲得量身打造的報價方案", "en": "Receive a tailored quotation", "ja": "カスタマイズされた見積もりを受け取る" }
        },
        {
          num: "04",
          title: { "zh": "部署上線", "en": "Deploy", "ja": "導入展開" },
          desc: { "zh": "系統安裝、教育訓練與技術支援", "en": "System installation and training", "ja": "システム設置とトレーニング" }
        }
      ],
      launchSteps: [
        {
          num: "01",
          title: { "zh": "簽署 MOU & 前線部署", "en": "MOU & Forward Deploy", "ja": "MOU 締結 & 現場派遣" },
          desc: { "zh": "簽署合作備忘錄，派駐工程師至客戶現場了解人力挑戰", "en": "Sign MOU and send engineer to your site to understand labor challenges", "ja": "MOUを締結し、エンジニアを現場に派遣して課題を把握" }
        },
        {
          num: "02",
          title: { "zh": "設計與開發", "en": "Design & Develop", "ja": "設計・開発" },
          desc: { "zh": "針對您的需求設計並開發專屬的機器人與自動化產品", "en": "Design and develop a robot tailored to your specific needs", "ja": "ニーズに合わせたロボット・自動化製品を設計・開発" }
        },
        {
          num: "03",
          title: { "zh": "最低訂購量報價", "en": "Quote with MOQ", "ja": "最小発注数での見積" },
          desc: { "zh": "根據開發成果提供最低訂購量報價", "en": "Receive a quotation with minimum order quantity", "ja": "最小発注数での見積もりを受け取る" }
        },
        {
          num: "04",
          title: { "zh": "部署與持續進化", "en": "Deploy & Evolve", "ja": "導入・継続進化" },
          desc: { "zh": "部署系統，持續監控、維護與 AI 學習適應新場景", "en": "Deploy with continuous monitoring, maintenance, and AI learning", "ja": "導入後も継続的な監視・保守・AI学習で進化" }
        }
      ],
      ctaText: {
        "zh": "開始合作",
        "en": "Start Your Journey",
        "ja": "パートナーシップを始める"
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  render() {
    const lang = this.state.lang;
    const { activeTab } = this.state;
    const steps = activeTab === "standard" ? this.state.standardSteps : this.state.launchSteps;
    const tabColor = activeTab === "standard" ? "var(--sub2-color)" : "var(--sub1-color)";

    return (
      <div className="collab-process-section">
        <div className="collab-process-inner">
          <Fade duration={800} delay={200}>
            <h2 className="collab-process-title">{this.state.sectionTitle[lang]}</h2>
          </Fade>

          <Fade duration={600} delay={300}>
            <div className="collab-tabs">
              <button
                className={"collab-tab" + (activeTab === "standard" ? " collab-tab-active collab-tab-standard" : "")}
                onClick={() => this.setState({ activeTab: "standard" })}
              >
                {this.state.tabs.standard[lang]}
              </button>
              <button
                className={"collab-tab" + (activeTab === "launch" ? " collab-tab-active collab-tab-launch" : "")}
                onClick={() => this.setState({ activeTab: "launch" })}
              >
                {this.state.tabs.launch[lang]}
              </button>
            </div>
          </Fade>

          <div className={"collab-stepper collab-stepper-" + activeTab} key={activeTab}>
            {steps.map((step, index) => (
              <Fade duration={600} delay={100 + index * 100} key={activeTab + index}>
                <div className="collab-step">
                  <div className="collab-step-num" style={{ borderColor: tabColor, color: tabColor }}>
                    {step.num}
                  </div>
                  {index < steps.length - 1 && (
                    <div className="collab-step-connector" style={{ background: `linear-gradient(90deg, ${tabColor} 0%, transparent 100%)` }} />
                  )}
                  <div className="collab-step-content">
                    <h3 className="collab-step-title">{step.title[lang]}</h3>
                    <p className="collab-step-desc">{step.desc[lang]}</p>
                  </div>
                </div>
              </Fade>
            ))}
          </div>

          <Fade duration={800} delay={600}>
            <div className="collab-process-cta-wrap">
              <button className="collab-process-cta" onClick={() => this.props.navigate('/about/colab_flow')}>
                {this.state.ctaText[lang]}
              </button>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

export default CollabProcessSection;
